import { UntypedFormGroup } from '@angular/forms';
import { LoginHeaderContent } from '../../../shared/login-header/models/login-header.interface';
import { NextDisplayView } from '../../login-authentication-screen/models/login-credentials.interface';

export interface CreateMyPasswordContent {
  formGroup: UntypedFormGroup;
  pageContent: CreateMyPasswordPageContent;
  formAttributes: CreateMyPasswordFormAttributes;
  showOverlayMessage: boolean;
  overlayMessage: string;
}

export interface CreateMyPasswordPageContent {
  pageHeader: LoginHeaderContent;
  canNotContainLabel: string;
  cannotContainList: string[];
  confirmPasswordLabel: string;
  confirmPasswordText: string;
  mustContainLabel: string;
  mustContainList: string[];
  newPasswordLabel: string;
  newPasswordText: string;
  nextDisplayView: NextDisplayView;
  viewName: string;
  messages: CreateMyPasswordMessages;
  showPassword: boolean;
}

export interface CreateMyPasswordMessages {
  newPasswordErrorMessage: string;
  confirmPasswordErrorMessage: string;
  alertWarning: string;
  cannotContainValidationList: string[];
  mustContainValidationList: string[];
}

export interface CreateMyPasswordFormAttributes {
  errorCount: number;
  submitAttempt?: boolean;
  errorAlertBanner: boolean;
  newPasswordControlTouched: boolean;
  confirmPasswordControlTouched: boolean;
  disableActionButton: boolean;
}

export interface InputValueEvent {
  id: string;
  value: string;
  codeKey: string | number;
}
